<template>
	<div>
		<form novalidate>
			<md-dialog :md-active="$route.name == 'createPCB'" :md-click-outside-to-close=false :md-close-on-esc=false @md-clicked-outside="close" @keydown.esc="close">
				<md-dialog-title>Create</md-dialog-title>
				<md-dialog-content>
					<div class="md-layout">
						<div class="md-layout-item">
							<md-field :class="getValidationClass('name')">
								<label for="name">Name</label>
								<md-input name="name" id="name" v-model="name" :disabled="sending" required/>
								<span class="md-error" v-if="!$v.name.required">Name is required</span>
							</md-field>
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item">
							<md-field>
								<label for="description">Description</label>
								<md-input name="description" id="description" v-model="description" :disabled="sending" />
							</md-field>
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item">
							<md-field :class="getValidationClass('designSource')">
								<label for="designSource">Design source</label>
								<md-input name="designSource" id="designSource" v-model="designSource" :disabled="sending" required />
								<span class="md-error" v-if="!$v.designSource.required">Design source is required</span>
							</md-field>
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item">
							<md-field>
								<label for="attachments">Attachements</label>
								<md-file id="attachmentInput" multiple />
							</md-field>
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item">
						<md-chips v-model="tags" md-placeholder="Tags"></md-chips>
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item">
						<dialog-link-table :links="links"/>
						</div>
					</div>

					<md-progress-bar md-mode="indeterminate" v-if="sending" />
					<md-dialog-actions>
						<md-button class="md-primary" @click="close()">Cancel</md-button>
						<md-button type="submit" class="md-primary" @click="validatePCB()" :disabled="sending">Create</md-button>
					</md-dialog-actions>
				</md-dialog-content>
			</md-dialog>
		</form>
	</div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import {
	required
} from 'vuelidate/lib/validators'
import DialogLinkTable from '../Common/DialogLinkTable.vue'

export default {
	name: 'Create',
	mixins: [validationMixin],
	components: { 'dialog-link-table': DialogLinkTable },
	data: () => ({
		name: null,
		description: null,
		tags: [],
		attachments: [],
		links: [],
		designSource: null,
		sending: false,
	}),
	validations: {
		name: {
			required
		},
		designSource: {
			required
		}
	},
	methods: {
		getValidationClass(fieldName) {
			const field = this.$v[fieldName]

			if (field) {
				return {
					'md-invalid': field.$invalid && field.$dirty
				}
			}
		},
		clearForm() {
			this.$v.$reset()
			this.name = null
			this.description = null
			this.designSource = null
			this.tags = []
			this.links = []
			this.sending = false
		},
		async createPCB() {
			this.sending = true

			try {
				const tagIds = await this.$apiService.createTagsIfNotExist(this.tags)
				const pcb = await this.$apiService.pcb.create({
					name: this.name,
					description: this.description,
					designSource: this.designSource,
					tagIds,
					links: this.links,
					namespaceId: parseInt(this.$route.params.id)
				})
				let i
				for (i = 0; i < document.querySelector('#attachmentInput').files.length; i++) {
					const data = new FormData()
					data.append('name', document.querySelector('#attachmentInput').files[i].name)
					data.append('data', document.querySelector('#attachmentInput').files[i])
					await this.$apiService.attachment.createAttachment({ name: 'pcb', id: pcb.id }, data)
				}
				this.$snackbar.showMessage('PCB saved!')
				this.close()
			} catch (e) {
				this.$snackbar.showMessage(e)
			}
			this.sending = false
		},
		async validatePCB() {
			this.$v.$touch()

			if (!this.$v.$invalid) {
				await this.createPCB()
			}
		},
		async close() {
			this.sending = false
			this.clearForm()
			try {
				await this.$store.dispatch('loadPCBs', { sortBy: this.sortBy, sortOrder: this.sortOrder })
			} catch (e) {
				this.$snackbar.showMessage(e)
			}
			this.$router.back()
		}
	}
}
</script>
